import { stringify } from 'qs';

interface IGetRealtorFormUrlParams {
  absoluteUrl?: boolean;
  isWebview?: boolean;
  cianSource?: string;
}

export function getRealtorFormUrl({ absoluteUrl, isWebview, cianSource }: IGetRealtorFormUrlParams = {}) {
  const webview = isWebview ? 1 : null;
  const cian_source = cianSource || null;

  const parameters = stringify({ webview, cian_source }, { addQueryPrefix: true, skipNulls: true });

  let url = `/application-form/${parameters}`;

  /* istanbul ignore next */
  if (absoluteUrl && typeof window !== 'undefined') {
    url = window.location.origin + url;
  }

  return {
    url,
  };
}
